import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { MVKPhase } from '../../types/mvk_state';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var InfoTooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(InfoTooltip, _React$Component);
  var _super = _createSuper(InfoTooltip);
  function InfoTooltip() {
    var _this;
    _classCallCheck(this, InfoTooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getInfoTooltipText", function () {
      var _this$props = _this.props,
        shouldShowFullScreenTip = _this$props.shouldShowFullScreenTip,
        isFullScreen = _this$props.isFullScreen,
        currentPhase = _this$props.currentPhase,
        isPanoramaActive = _this$props.isPanoramaActive;
      var phaseText = currentPhase === MVKPhase.PREVIEW && !isPanoramaActive ? 'Выберите корпус' : undefined;
      return isFullScreen && shouldShowFullScreenTip ? 'Чтобы выйти из полноэкранного режима, нажмите Esc' : phaseText;
    });
    return _this;
  }
  _createClass(InfoTooltip, [{
    key: "render",
    value: function render() {
      var title = this.getInfoTooltipText();
      if (!title) {
        return null;
      }
      return /*#__PURE__*/_jsx("div", {
        className: styles['info_tooltip'],
        children: /*#__PURE__*/_jsx("span", {
          children: title
        })
      });
    }
  }]);
  return InfoTooltip;
}(React.Component);